import { Injectable } from '@angular/core';
import { HttpBypassInterceptorClientService } from './core/services/http-bypass-interceptor-client.service';
import { formatDate } from '@angular/common';
import { IInterceptorSettings } from '@tpapa/citywire-internal-accounts-angular/lib/models/citywire-accounts-inteceptor-settings';
import { ICitywireAmplifyConfig } from '@tpapa/citywire-internal-accounts-angular';
import { cmsAuthRedirect } from './base-href';

@Injectable()
export class AppConfig {
  public cmsUrl: string = null;
  public shakespeareUrl: string = null;
  public isRaygunEnabled: false;

  public authorizationCookieName: string = null;
  public userNameCookieName: string = null;
  public userRolesUrl: string = null;
  public refreshUserNameCookieUrl: string = null;
  public environment: string = null;

  cmsApiBaseUrl: string = null;
  contentResultLimit: number;
  topicsUrl: string;
  audienceContentUrl: string;
  tagEngagementUrl: string;
  fundOfFundsUrl: string;
  topicTagRatesDayRange: number;
  topManagersUrl: string;
  emailActivityUrl: string;

  public amrUrl: string;
  public taggingFAQ: string;

  inteceptorSettings: IInterceptorSettings;
  authProviderName: string;
  cloudfrontUrl?: string;
  amplifyConfig?: ICitywireAmplifyConfig;

  constructor(
    private httpBypassInterceptor: HttpBypassInterceptorClientService
  ) {}

  public async load(): Promise<void> {
    // should not intercept config.json call as it causes circular dependecy
    try {
      const date = formatDate(new Date(), 'yyyyMMddHHmmss', 'en');
      const config = await this.httpBypassInterceptor
        .get<AppConfig>('./assets/config.json?t=' + date)
        .toPromise();

      // tslint:disable:no-string-literal
      this.cmsUrl = config['citywire']['general']['cmsUrl'];
      this.shakespeareUrl = config['citywire']['general']['shakespeareUrl'];
      this.isRaygunEnabled = config['citywire']['general']['isRaygunEnabled'];
      this.authorizationCookieName =
        config['citywire']['authorization']['cookieName'];
      this.userNameCookieName =
        config['citywire']['authorization']['userNameCookieName'];

      this.cmsApiBaseUrl = config['citywire']['cmsWebApi']['baseUrl'];
      this.contentResultLimit =
        config['citywire']['general']['contentResultLimit'];
      this.audienceContentUrl =
        config['citywire']['reporting']['audienceContentUrl'];
      this.tagEngagementUrl =
        config['citywire']['reporting']['tagEngagementUrl'];
      this.fundOfFundsUrl = config['citywire']['reporting']['fundOfFundsUrl'];
      this.topManagersUrl = config['citywire']['reporting']['topManagersUrl'];
      this.emailActivityUrl =
        config['citywire']['reporting']['emailActivityUrl'];
      this.topicTagRatesDayRange =
        config['citywire']['reporting']['topicTagRatesDayRange'];
      this.userRolesUrl = config['citywire']['general']['userRolesUrl'];
      this.refreshUserNameCookieUrl =
        config['citywire']['general']['refreshUserNameCookieUrl'];
      this.environment = config['citywire']['general']['environment'];
      this.amrUrl = config['citywire']['general']['amrUrl'];
      this.taggingFAQ = config['citywire']['general']['taggingFAQ'];
      this.inteceptorSettings = {
        excludeLocalRequests:
          config['citywireAuthentication']['inteceptorSettings'][
            'excludeLocalRequests'
          ],
        excludeUrls:
          config['citywireAuthentication']['inteceptorSettings']['excludeUrls'],
      };
      this.authProviderName = config['citywireAuthentication']['providerName'];
      this.cloudfrontUrl = config['citywireAuthentication']['cloudfrontUrl'];
      this.amplifyConfig = this.getCitywireAmplifyConfig(
        config['citywireAuthentication']['auth']
      );
    } catch (error) {
      const errorMessage = 'Error reading app config: ' + error.message;
      console.log(errorMessage);
    }
  }

  getCitywireAmplifyConfig(authConfig: any): ICitywireAmplifyConfig {
    return {
      region: authConfig['region'],
      userPoolId: authConfig['userPoolId'],
      userPoolWebClientId: authConfig['userPoolWebClientId'],
      oauth: {
        domain: authConfig['oauth']['domain'],
        scope: authConfig['oauth']['scope'],
        redirectSignIn: cmsAuthRedirect(
          window.location.origin,
          window.location.pathname
        ),
        redirectSignOut: cmsAuthRedirect(
          window.location.origin,
          window.location.pathname
        ),
        responseType: authConfig['oauth']['responseType'],
        options: {
          advancedSecurityDataCollectionFlag:
            authConfig['oauth']['options'][
              'advancedSecurityDataCollectionFlag'
            ],
        },
      },
    };
  }
}
